var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3295_418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8044 12.8033C15.7334 9.87437 15.7334 5.12563 12.8044 2.1967C9.8755 -0.732232 5.12676 -0.732233 2.19783 2.1967C-0.7311 5.12563 -0.7311 9.87437 2.19783 12.8033C5.12676 15.7322 9.8755 15.7322 12.8044 12.8033Z",
    fill: "#515CD1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5203 10.8085C3.14178 10.6844 2.88689 10.4363 2.75017 10.0611C2.4168 9.14458 2.31848 5.31123 2.9599 4.55587C3.17933 4.29804 3.46164 4.14697 3.79797 4.11068C5.52685 3.92458 10.8705 3.95116 11.4866 4.17313C11.8474 4.30268 12.1031 4.53899 12.2428 4.90022C12.6074 5.84758 12.6201 9.29396 12.1947 10.2067C12.0795 10.454 11.8917 10.6287 11.6524 10.754C11.0076 11.0925 4.36892 11.0883 3.52072 10.8085H3.5203ZM6.2666 9.01207C7.30638 8.47277 8.33687 7.93853 9.38045 7.39712C8.33519 6.85191 7.30469 6.3143 6.2666 5.77247V9.01207Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3295_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fd559fd867db4c03f71bd967d009f0e8.svg";
export { ForwardRef as ReactComponent };